import { Component, EventEmitter, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatRippleModule } from '@angular/material/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { FullscreenComponent } from '@base/components/fullscreen';
import { ThemeSwitcherComponent } from 'app/layout/common/theme-switcher/theme-switcher.component';
import { UserComponent } from 'app/layout/common/user/user.component';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.scss',
  imports: [
    MatButtonModule,
    MatExpansionModule,
    MatIconModule,
    MatListModule,
    MatRippleModule,
    FullscreenComponent,
    UserComponent,
    ThemeSwitcherComponent,
    MatToolbarModule,
    MatSidenavModule,
  ],
})
export class NavbarComponent {
  @Output() toggleSidenav = new EventEmitter<void>();
}
